import { getCities } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setActiveCitiesAction } from '../../store/city/action'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { compose } from 'redux'

const SearchTrendsContainer = (props: ConnectedProps<typeof withConnect>) => {
  useEffect(() => {
    getCities().then(res => {
      const { setActiveCitiesAction } = props
      setActiveCitiesAction(res)
    })
  }, [])

  const getNavBarTitle = () => {
    return translate('navBar.searchTrendsTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setActiveCitiesAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(SearchTrendsContainer)
